import domUtils from 'util/dom-utils'
import { widgetLibraries } from 'init/command-queue'
import { TopCommentsConfig as ITopCommentsConfig } from 'services/api-service'
import { loadConfig } from './top-comments.config'
import * as topCommentsCommands from './top-comments-commands'
import processTopComments from './top-comments'

export const type = 'top-comments'

export function loadWidget(widgetConfig: ITopCommentsConfig) {
  return new Promise((resolve) => {
    loadConfig(widgetConfig)
    widgetLibraries.topComments = topCommentsCommands
    domUtils.onDomReady().then(() => {
      resolve()
      // once dom is ready, we load comments for all divs client has provided
      processTopComments()
    })
  })
}
